import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { VoteItem } from "core/http/service/internalEvents/types";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data?: VoteItem[];
}

const initialState: InitialState = { status: ReduxStateType.INIT, data: [] };

const getVotesSlice = createSlice({
  name: "getVotes",
  initialState,
  reducers: {
    getVotesStart: (state, action: PayloadAction<{ awardId: string }>) => {
      state.status = ReduxStateType.LOADING;
    },
    getVotesSuccess: (
      state,
      action: PayloadAction<{
        data: VoteItem[];
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = [...state.data, ...action.payload.data];
    },
    getVotesFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = [];
    },
    resetVotes: () => initialState,
  },
});

export const { getVotesStart, getVotesSuccess, getVotesFailed, resetVotes } =
  getVotesSlice.actions;

export default getVotesSlice.reducer;
